import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Header from "./components/UI/Header";
import Footer from "./components/UI/Footer";

import "./app.css";

import LoadingSpinner from "./components/loadingSpinner/LoadingSpinner";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import LoginModal from "./components/auth/LoginModal";

const Home = React.lazy(() => import("./components/pages/home/home"));
const Info = React.lazy(() => import("./components/pages/info/Info"));
const About = React.lazy(() => import("./components/pages/about/about"));
const Gallery = React.lazy(() => import("./components/pages/gallery/Gallery"));
const Contact = React.lazy(() => import("./components/pages/contact/Contact"));
const NotFound = React.lazy(() => import("./components/pages/notFound/NotFound"));
const Portal = React.lazy(() => import("./components/pages/portal/Portal"));
const AdminUsers = React.lazy(() => import("./components/pages/admin/AdminUsers"));
const AdminPhotos = React.lazy(() => import("./components/pages/admin/AdminPhotos"));

function App() {
  return (
    <div className="app">
      <Header />
      <LoginModal />

      <section>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/info" element={<Info />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <Portal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <Navigate to="/admin/users" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/photos"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPhotos />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </section>

      <Footer />
    </div>
  );
}

export default App;
